import React, { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { fetchGallery } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchGallery()
      .then(setItems)
      .catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  // Bento grid mapping for up to 5 items
  const spans = [
    "md:col-span-8 md:row-span-2",
    "md:col-span-4",
    "md:col-span-4",
    "md:col-span-6",
    "md:col-span-6",
  ];
  const preview = items.slice(0, 5);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-20 bg-[#F5DCD5]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.22em] text-[#B37C7C] font-medium mb-4">
              Our Cookies
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#362C2C] leading-[1.05]">
              A few of our
              <span className="italic font-accent-serif text-[#B37C7C]"> favorites.</span>
            </h2>
          </div>
          <p className="text-[#5C5252] max-w-md leading-relaxed">
            Halloween boxes, party favors, gift trios and more — each set made fresh
            for the occasion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6" data-testid="gallery-grid">
          {preview.map((item, idx) => (
            <a
              key={item.id}
              href="/gallery"
              className={`group relative overflow-hidden rounded-lg ${spans[idx] || "md:col-span-4"} ${
                idx === 0 ? "aspect-[4/5] md:aspect-auto md:min-h-[520px]" : "aspect-[4/5]"
              }`}
              data-testid={`gallery-item-${item.id}`}
            >
              <img
                src={item.image}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#362C2C]/50 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-7">
                {item.blurb && (
                  <div className="text-[10px] uppercase tracking-[0.22em] text-white/80 mb-2">
                    {item.blurb}
                  </div>
                )}
                <div className="font-serif-display text-2xl md:text-3xl text-white">
                  {item.title}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-14 flex justify-center">
          <a
            href="/gallery"
            className="group inline-flex items-center gap-2 border border-[#B37C7C] text-[#B37C7C] px-7 py-3.5 rounded-md hover:bg-[#F7EBEB] transition-all duration-300 tracking-wide text-sm"
            data-testid="gallery-view-all"
          >
            View the full gallery
            <ArrowRight
              size={16}
              className="group-hover:translate-x-1 transition-transform duration-300"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
